import React from 'react';
import { Route, Link } from "react-router-dom";
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import '../../assets/css/App.css';

import Director from './Director';
import Member from './Member';
import Graduates from './Graduates';
import InternDoctors from './intern-doctor';

//import BlindedReview from './BlindedReview';

import routes from '../../model/router';
import Header1 from '../public';


  const {
    Header, Content, Footer, Sider,
  } = Layout;
  const SubMenu = Menu.SubMenu;


class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           
        };
    }

    render() {
        return (
            <div>
              <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{ background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%' }}
                  >
                    
                    <SubMenu key="sub1" title={<span><Icon type="user" />Staff</span>}>
                      <Menu.Item key="1"><Link to="/director">Director</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/member">Member</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub2" title={<span><Icon type="user" />Students</span>}>
                      <Menu.Item key="3"><Link to="/graduates">Graduates</Link></Menu.Item>
                      <Menu.Item key="4"><Link to="/intern-doctors">Intern doctors</Link></Menu.Item>
                    </SubMenu>
                    
                    {/*
                    <SubMenu key="sub1" title={<span><Icon type="user" />Review</span>}>
                      <Menu.Item key="1"><Link to="/BlindedReview">Blinded-Review</Link></Menu.Item>
                    </SubMenu>
                    */}
                  </Menu>
                </Sider>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                
                </Content>
              </Layout>
            </Content>
            </div>
          
        )
    }
}
export default Contact;